import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "chip-field";
var attributes = {
    INVALID: 'invalid',
    REQUIRED: 'required',
    DISABLED: 'disabled',
    HOST_LABEL_FLOATING: elementName + "-label-floating",
    FLOAT_LABEL_TYPE: 'float-label-type',
};
var classes = {
    ROOT: 'tyl-chip-field',
    INVALID: 'tyl-chip-field--invalid',
    REQUIRED: 'tyl-chip-field--required',
    DISABLED: 'tyl-chip-field--disabled',
    FOCUSED: 'tyl-chip-field--focused',
    INPUT_FOCUSED: 'tyl-chip-field__input--focused',
    LABEL_FOCUSED: 'tyl-chip-field__label--focused',
};
var slots = {
    LABEL: 'label',
    HELPER_TEXT: 'helper-text',
    MEMBER: 'member',
};
var selectors = {
    ROOT: "." + classes.ROOT,
    CONTENT: '.tyl-chip-field__content',
    INPUT: 'input',
    LABEL: "[slot=" + slots.LABEL + "]",
    HELPER_TEXT: "[slot=" + slots.HELPER_TEXT + "]",
    MEMBER: "[slot=" + slots.MEMBER + "]",
    NOTCHED_OUTLINE: '.mdc-notched-outline',
    LABEL_SLOT: "slot[name=" + slots.LABEL + "]",
    MEMBER_SLOT: "slot[name=" + slots.MEMBER + "]",
};
var events = {
    MEMBER_ADDED: elementName + "-member-added",
    MEMBER_REMOVED: elementName + "-member-removed"
};
var numbers = {
    FLOATING_LABEL_SCALE_FACTOR: 0.75
};
export var CHIP_FIELD_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    slots: slots,
    selectors: selectors,
    attributes: attributes,
    events: events,
    numbers: numbers
};
